const utmParams = (source = '', medium = '') => {
  return { utm_source: source, utm_medium: medium }
}

const fallback = data => {
  if (data.utm_source || data.utm_medium) {
    return utmParams(data.utm_source, data.utm_medium)
  }

  if (!document.referrer) {
    return utmParams('direct', '(not set)')
  }

  if (document.referrer.indexOf('google.com') > -1) {
    return utmParams('google', 'organic')
  }

  return utmParams(document.referrer, 'referral')
}

class UtmNormalizer {
  static call(data) {
    const alternateParams = fallback(data)

    const utms = {
      utm_source: data.utm_source || alternateParams.utm_source || undefined,
      utm_medium: data.utm_medium || alternateParams.utm_medium || undefined,
      utm_campaign: data.utm_campaign || undefined,
      utm_term: data.utm_term || undefined,
      utm_content: data.utm_content || undefined,
    }

    return utms
  }
}

export default UtmNormalizer
